export const DEFAULT_AMOUNT_BOX_VALUE = 0;
export const DEFAULT_AMOUNT_BOX_BIT = 2;
export const DEFAULT_AMOUNT_BOX_CURRENCY_CODE = 'HK$';
export const DEFAULT_AMOUNT_BOX_SIZE = 92;

/**
 * 组件的props
 */
export const props = {
  /**
   * 金额（分）
   * @default 0
   */
  value: {
    type: Number,
    default: DEFAULT_AMOUNT_BOX_VALUE,
  },
  /**
   * 金额展示小数点位数
   * @default 2
   */
  bit: {
    type: Number,
    default: DEFAULT_AMOUNT_BOX_BIT,
  },
  /**
   * 币种代码
   * @default 'HK$'
   */
  currencyCode: {
    type: String,
    default: DEFAULT_AMOUNT_BOX_CURRENCY_CODE,
  },
  /**
   * 金额字体大小，视觉稿提供的金额font-size
   * @default 92
   */
  size: {
    type: Number,
    default: DEFAULT_AMOUNT_BOX_SIZE,
  },
};
